import apiUtil from './apiUtil';

let linkPreviewApi = {};

linkPreviewApi.fetchLinkPreview = function(url) {
    return apiUtil.runRequest('/api/private/linkpreview?url=' + encodeURIComponent(url));
};

export default linkPreviewApi;
